(function ($) {
    $(document).ready(function () {
        if ($(window).width() < 992) {
            $('.fullscreen-menu .treatments-menu').append('<ul class="sub-menu" />');
            $('.fullscreen-menu .problem-menu').append('<ul class="sub-menu" data-type="problems" />');
            $('.problems-mega-menu .content a').each(function(){
                $('.fullscreen-menu .problem-menu .sub-menu').append('<li><a href="'+$(this).attr('href')+'">'+$(this).html()+'</a></li>');
            })
            $.when(
                $('.treatments-mega-menu .categories a').each(function () {
                    $('.fullscreen-menu .treatments-menu .sub-menu').append('<li class="menu-item-has-children" data-slug="'+$(this).attr('data-slug')+'"><a href="' + $(this).attr('href') + '">' + $(this).html() + '</a></li>');
                })
            ).then(
                $('.treatments-mega-menu .treatments .term-submenu').each(function () {
                    var slug = $(this).attr('data-slug');
                    $('.fullscreen-menu .treatments-menu .sub-menu li[data-slug="'+slug+'"]').append('<ul class="sub-menu treatments-sub-menu" />');
                    $(this).find('a').each(function(){
                        $('.fullscreen-menu .treatments-menu .sub-menu li[data-slug="'+slug+'"] .sub-menu').append('<li><a href="' + $(this).attr('href') + '">' + $(this).html() + '</a>');
                    });
                })
            );
        } else {
            $('.treatments-mega-menu').appendTo('.treatments-menu');
            $('.problems-mega-menu').appendTo('.problem-menu');
            $('.treatments-mega-menu .categories a').first().addClass('active');
            $('.treatments-mega-menu .treatments .term-submenu').first().addClass('active');
        }
    })
    $('.treatments-mega-menu .categories a, .treatments-mega-menu .treatments .term-submenu').hover(function () {
        $('.treatments-mega-menu .treatments .term-submenu').hide();
        $('.treatments-mega-menu .treatments .term-submenu[data-slug="' + $(this).attr('data-slug') + '"]').css('display', 'flex');
    }, function () {
        $('.treatments-mega-menu .treatments .term-submenu').hide();
        $('.treatments-mega-menu .categories a, .treatments-mega-menu .treatments .term-submenu').removeClass('active');
    });

})(jQuery)